<script lang="ts">
    import {_} from 'svelte-i18n'
    import Button from '@smui/button';
    import {Label} from '@smui/common';
    import Editor from 'cl-editor';
    import {createEventDispatcher, onMount} from 'svelte';
    import {tick} from 'svelte/internal';
    import type {DefinedMessage} from './types';

    export let definedMessage: DefinedMessage;
    export let disabled: boolean = false;

    const dispatch = createEventDispatcher();
    let editorElement: HTMLElement;
    let definedMessageHtml: string;
    let modificationSaved: boolean = true;

    function save() {
        dispatch('save', definedMessage);
    }

    onMount(() => {
        tick().then(() => {
            const editor = new Editor({
                target: editorElement,
                props: {
                    actions: ['h1', 'h2', 'p', 'b', 'i', 'u', 'strike', 'ul', 'ol']
                }
            });

            editor.$on('change', event => {
                modificationSaved = false;
                definedMessageHtml = event.detail;
            });

            editor.setHtml(definedMessage.text);
        });
    });

    async function submit() {
        definedMessage.text = definedMessageHtml;
        save();
        modificationSaved = true;
    }
</script>

<form on:submit|preventDefault={submit}>

    <div bind:this={editorElement} style="width: 100%;"></div>

    <div style="min-width: 160px;">
        <Button type="submit" disabled={disabled || modificationSaved} variant="unelevated">
            <Label>
                {#if modificationSaved}
                    {$_('commons.Saved')}
                {:else}
                    {$_('commons.Save')}
                {/if}
            </Label>
        </Button>
    </div>
</form>